import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { IllegalArgumentException2asla15b5jaob as IllegalArgumentException } from '../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import {
  toString1pkumu07cwy4m as toString,
  protoOf180f3jzyo7rfj as protoOf,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  equalsLowerCase1477z9rxwgcv2 as equalsLowerCase,
  hashCodeLowerCase2r6jfpu8gi2u9 as hashCodeLowerCase,
} from './internals/Chars.mjs';
import { abs1kdzbjes1idip as abs } from '../../../../../kotlin-kotlin-stdlib/kotlin/math/math.mjs';
import { StringBuildermazzzhj6kkai as StringBuilder } from '../../../../../kotlin-kotlin-stdlib/kotlin/text/StringBuilderJs.mjs';
import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  SequenceScope1coiso86pqzq2 as SequenceScope,
  sequence2vgswtrxvqoa7 as sequence,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/sequences/SequenceBuilder.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { DefaultPool2gb1fm4epwgu9 as DefaultPool } from '../../../../../ktor-ktor-io/io/ktor/utils/io/pool/DefaultPool.mjs';
import { fill2542d4m9l93pn as fill } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/_ArraysJs.mjs';
import { isIntArrayeijsubfngq38 as isIntArray } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
function get_IntArrayPool() {
  _init_properties_HttpHeadersMap_kt__hwatby();
  return IntArrayPool;
}
var IntArrayPool;
function get_HeadersDataPool() {
  _init_properties_HttpHeadersMap_kt__hwatby();
  return HeadersDataPool;
}
var HeadersDataPool;
function thresholdReached($this) {
  return $this.t56_1 >= $this.u56_1 * 0.75;
}
function resize($this) {
  var prevSize = $this.t56_1;
  var prevData = $this.v56_1;
  $this.t56_1 = 0;
  $this.u56_1 = imul($this.u56_1, 2) | 128;
  var tmp = $this;
  // Inline function 'kotlin.apply' call
  var this_0 = get_HeadersDataPool().y4l();
  this_0.y56(imul(prevData.x56(), 2) | 1);
  tmp.v56_1 = this_0;
  var _iterator__ex2g4s = prevData.z56().p1();
  while (_iterator__ex2g4s.q1()) {
    var headerOffset = _iterator__ex2g4s.r1();
    $this.b57(prevData.a57(headerOffset + 1 | 0), prevData.a57(headerOffset + 2 | 0), prevData.a57(headerOffset + 3 | 0), prevData.a57(headerOffset + 4 | 0));
  }
  get_HeadersDataPool().z4l(prevData);
  // Inline function 'kotlin.require' call
  // Inline function 'kotlin.require' call
  if (!(prevSize === $this.t56_1)) {
    var message = 'Failed requirement.';
    throw IllegalArgumentException().n2(toString(message));
  }
}
function headerHasName($this, name, headerOffset) {
  var nameStartIndex = $this.v56_1.a57(headerOffset + 1 | 0);
  var nameEndIndex = $this.v56_1.a57(headerOffset + 2 | 0);
  return equalsLowerCase($this.s56_1, nameStartIndex, nameEndIndex, name);
}
var HttpHeadersMapClass;
function HttpHeadersMap() {
  if (HttpHeadersMapClass === VOID) {
    class $ {
      constructor(builder) {
        this.s56_1 = builder;
        this.t56_1 = 0;
        this.u56_1 = 0;
        this.v56_1 = get_HeadersDataPool().y4l();
      }
      m2o(name) {
        if (this.t56_1 === 0)
          return null;
        // Inline function 'kotlin.math.absoluteValue' call
        var this_0 = hashCodeLowerCase(name);
        var hash = abs(this_0);
        var headerIndex = hash % this.u56_1 | 0;
        while (!(this.v56_1.a57(imul(headerIndex, 6) + 0 | 0) === -1)) {
          if (headerHasName(this, name, imul(headerIndex, 6))) {
            return this.c57(imul(headerIndex, 6));
          }
          headerIndex = (headerIndex + 1 | 0) % this.u56_1 | 0;
        }
        return null;
      }
      d57() {
        return this.v56_1.z56();
      }
      b57(nameStartIndex, nameEndIndex, valueStartIndex, valueEndIndex) {
        if (thresholdReached(this)) {
          resize(this);
        }
        // Inline function 'kotlin.math.absoluteValue' call
        var this_0 = hashCodeLowerCase(this.s56_1, nameStartIndex, nameEndIndex);
        var hash = abs(this_0);
        var name = this.s56_1.c(nameStartIndex, nameEndIndex);
        var headerIndex = hash % this.u56_1 | 0;
        var sameNameHeaderIndex = -1;
        while (!(this.v56_1.a57(imul(headerIndex, 6) + 0 | 0) === -1)) {
          if (headerHasName(this, name, imul(headerIndex, 6))) {
            sameNameHeaderIndex = headerIndex;
          }
          headerIndex = (headerIndex + 1 | 0) % this.u56_1 | 0;
        }
        var headerOffset = imul(headerIndex, 6);
        this.v56_1.l57(headerOffset + 0 | 0, hash);
        this.v56_1.l57(headerOffset + 1 | 0, nameStartIndex);
        this.v56_1.l57(headerOffset + 2 | 0, nameEndIndex);
        this.v56_1.l57(headerOffset + 3 | 0, valueStartIndex);
        this.v56_1.l57(headerOffset + 4 | 0, valueEndIndex);
        this.v56_1.l57(headerOffset + 5 | 0, -1);
        if (!(sameNameHeaderIndex === -1)) {
          this.v56_1.l57(imul(sameNameHeaderIndex, 6) + 5 | 0, headerIndex);
        }
        this.t56_1 = this.t56_1 + 1 | 0;
      }
      m57(headerOffset) {
        var nameStartIndex = this.v56_1.a57(headerOffset + 1 | 0);
        var nameEndIndex = this.v56_1.a57(headerOffset + 2 | 0);
        return this.s56_1.c(nameStartIndex, nameEndIndex);
      }
      c57(headerOffset) {
        var valueStartIndex = this.v56_1.a57(headerOffset + 3 | 0);
        var valueEndIndex = this.v56_1.a57(headerOffset + 4 | 0);
        return this.s56_1.c(valueStartIndex, valueEndIndex);
      }
      j2m() {
        this.t56_1 = 0;
        this.u56_1 = 0;
        get_HeadersDataPool().z4l(this.v56_1);
        this.v56_1 = get_HeadersDataPool().y4l();
      }
      toString() {
        // Inline function 'kotlin.text.buildString' call
        // Inline function 'kotlin.apply' call
        var this_0 = StringBuilder().l1();
        dumpTo(this, '', this_0);
        return this_0.toString();
      }
    }
    initMetadataForClass($, 'HttpHeadersMap');
    HttpHeadersMapClass = $;
  }
  return HttpHeadersMapClass;
}
var HeadersData$headersStarts$slambdaClass;
function HeadersData$headersStarts$slambda() {
  if (HeadersData$headersStarts$slambdaClass === VOID) {
    class $ {
      constructor(this$0) {
        this.n57_1 = this$0;
      }
      *o57($this$sequence, $completion) {
        var joinedIndex = 0;
        var _iterator__ex2g4s = this.n57_1.w56_1.p1();
        while (_iterator__ex2g4s.q1()) {
          var arr = _iterator__ex2g4s.r1();
          var localIndex = 0;
          while (localIndex < arr.length) {
            if (!(this.n57_1.a57(joinedIndex + 0 | 0) === -1)) {
              yield* $this$sequence.ok(joinedIndex, $completion);
            }
            localIndex = localIndex + 6 | 0;
            joinedIndex = joinedIndex + 6 | 0;
          }
        }
        return Unit_instance;
      }
      ld(p1, $completion) {
        return this.o57(p1 instanceof SequenceScope() ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    HeadersData$headersStarts$slambdaClass = $;
  }
  return HeadersData$headersStarts$slambdaClass;
}
function HeadersData$headersStarts$slambda_0(this$0) {
  var i = new (HeadersData$headersStarts$slambda())(this$0);
  var l = ($this$sequence, $completion) => i.o57($this$sequence, $completion);
  l.$arity = 1;
  return l;
}
var HeadersDataClass;
function HeadersData() {
  if (HeadersDataClass === VOID) {
    class $ {
      constructor() {
        var tmp = this;
        // Inline function 'kotlin.collections.mutableListOf' call
        tmp.w56_1 = ArrayList().p2();
      }
      x56() {
        return this.w56_1.q2();
      }
      y56(subArraysCount) {
        // Inline function 'kotlin.repeat' call
        var inductionVariable = 0;
        if (inductionVariable < subArraysCount)
          do {
            var index = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            this.w56_1.i2(get_IntArrayPool().y4l());
          }
           while (inductionVariable < subArraysCount);
      }
      a57(index) {
        return this.w56_1.r2(index / 768 | 0)[index % 768 | 0];
      }
      l57(index, value) {
        this.w56_1.r2(index / 768 | 0)[index % 768 | 0] = value;
      }
      z56() {
        return sequence(HeadersData$headersStarts$slambda_0(this));
      }
      j2m() {
        var _iterator__ex2g4s = this.w56_1.p1();
        while (_iterator__ex2g4s.q1()) {
          var array = _iterator__ex2g4s.r1();
          get_IntArrayPool().z4l(array);
        }
        this.w56_1.a5();
      }
    }
    initMetadataForClass($, 'HeadersData', HeadersData);
    HeadersDataClass = $;
  }
  return HeadersDataClass;
}
function dumpTo(_this__u8e3s4, indent, out) {
  _init_properties_HttpHeadersMap_kt__hwatby();
  var _iterator__ex2g4s = _this__u8e3s4.d57().p1();
  while (_iterator__ex2g4s.q1()) {
    var offset = _iterator__ex2g4s.r1();
    out.o2(indent);
    out.o2(_this__u8e3s4.m57(offset));
    out.o2(' => ');
    out.o2(_this__u8e3s4.c57(offset));
    out.o2('\n');
  }
}
var IntArrayPool$1Class;
function IntArrayPool$1() {
  if (IntArrayPool$1Class === VOID) {
    class $ extends DefaultPool() {
      constructor() {
        super(1000);
      }
      r4l() {
        var tmp = 0;
        var tmp_0 = new Int32Array(768);
        while (tmp < 768) {
          tmp_0[tmp] = -1;
          tmp = tmp + 1 | 0;
        }
        return tmp_0;
      }
      s57(instance) {
        fill(instance, -1);
        return protoOf(DefaultPool()).w4l.call(this, instance);
      }
      w4l(instance) {
        return this.s57(isIntArray(instance) ? instance : THROW_CCE());
      }
    }
    initMetadataForClass($);
    IntArrayPool$1Class = $;
  }
  return IntArrayPool$1Class;
}
var HeadersDataPool$1Class;
function HeadersDataPool$1() {
  if (HeadersDataPool$1Class === VOID) {
    class $ extends DefaultPool() {
      constructor() {
        super(1000);
      }
      r4l() {
        return new (HeadersData())();
      }
      w57(instance) {
        instance.j2m();
        return protoOf(DefaultPool()).w4l.call(this, instance);
      }
      w4l(instance) {
        return this.w57(instance instanceof HeadersData() ? instance : THROW_CCE());
      }
    }
    initMetadataForClass($);
    HeadersDataPool$1Class = $;
  }
  return HeadersDataPool$1Class;
}
var properties_initialized_HttpHeadersMap_kt_kotj4w;
function _init_properties_HttpHeadersMap_kt__hwatby() {
  if (!properties_initialized_HttpHeadersMap_kt_kotj4w) {
    properties_initialized_HttpHeadersMap_kt_kotj4w = true;
    IntArrayPool = new (IntArrayPool$1())();
    HeadersDataPool = new (HeadersDataPool$1())();
  }
}
//region block: exports
export {
  HttpHeadersMap as HttpHeadersMapp7szignu4ex,
};
//endregion

//# sourceMappingURL=HttpHeadersMap.mjs.map
